import { Component } from '@angular/core';
import { OperatorshiftsService } from 'app/services/operatorshifts.service';

@Component({
  selector: 'app-produccion',
  templateUrl: './produccion.component.html',
  styleUrls: ['./produccion.component.css']
})
export class ProduccionComponent {

  constructor(
    
  ) { 
    const sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    if (sidebar !== undefined) {
      sidebar.innerHTML = 'Producción';
    }
  }
  mostrarGraficos = true;

  toggleGraficos() {
    this.mostrarGraficos = !this.mostrarGraficos;
  }


 

}
